<div class="login-body">

  <div class="flex-row" id="login">
    <div class="flex-column"></div>
    <div class="flex-column-main">
      <app-login-brand></app-login-brand>

      <button class="manual-signin btn-lg" type="button" [disabled]="!signInEnabled" (click)="login()">Sign In</button>

    </div>
    <div class="flex-column"></div>
  </div>

</div>